import { QueryParameters as NonPersonalizedQueryParams } from "@faire/web-api--source/endpoints/www/api/v2/categories/navigation/get";
import { QueryParameters as PersonalizedQueryParams } from "@faire/web-api--source/endpoints/www/api/v2/categories/personalized/retailerToken/navigation/get";
import { ClientPlatformType } from "@faire/web-api--source/indigofair/data/ClientPlatformType";

type BaseArg = {
  clientPlatformType: ClientPlatformType;
  navigationTreeHashCode: string | undefined;
  locale: string;
};

type NonPersonalizedArg = BaseArg & {
  country: string | undefined;
};

export const buildNonPersonalizedQueryParams = ({
  clientPlatformType,
  navigationTreeHashCode,
  locale,
  country,
}: NonPersonalizedArg) => {
  return NonPersonalizedQueryParams.build({
    clientPlatformType,
    hashCode: navigationTreeHashCode,
    locale,
    country,
  });
};

type PersonalizedArg = BaseArg;

export const buildPersonalizedQueryParams = ({
  clientPlatformType,
  navigationTreeHashCode,
  locale,
}: PersonalizedArg) => {
  return PersonalizedQueryParams.build({
    clientPlatformType,
    hashCode: navigationTreeHashCode,
    locale,
  });
};
